import { forwardRef } from 'react';
import { ButtonBase } from './ButtonBase.js';
import { jsx } from 'react/jsx-runtime';

const LinkButton = /*#__PURE__*/forwardRef(({
  children,
  as: Component = 'a',
  ...props
}, forwardedRef) => {
  return /*#__PURE__*/jsx(ButtonBase, {
    as: Component,
    ref: forwardedRef,
    ...props,
    children: children
  });
});

export { LinkButton };
